import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const convertExchangeToCompensation = {
  name: "convertExchangeToCompensation" as const,
  input: z.object({
    returnId: zExt.objectId(),
    compensationMethod: z.enum(["refund", "store_credit"]),
  }),
  output: z.object({ success: z.boolean() }),
};
